import karachiAreasData from "./karachiAreas.json";

export type Option = { value: string; label: string };

export const gender: Option[] = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const bloodGroup: Option[] = [
  { value: "Unknown", label: "Unknown" },
  { value: "A +ve", label: "A +ve" },
  { value: "A -ve", label: "A -ve" },
  { value: "B +ve", label: "B +ve" },
  { value: "B -ve", label: "B -ve" },
  { value: "AB +ve", label: "AB +ve" },
  { value: "AB -ve", label: "AB -ve" },
  { value: "O +ve", label: "O +ve" },
  { value: "O -ve", label: "O -ve" },
];

export const religion: Option[] = [
  { value: "Islam", label: "Islam" },
  { value: "Christianity", label: "Christianity" },
  { value: "Buddhism", label: "Buddhism" },
  { value: "Other", label: "Other" },
];

export const motherTongue: Option[] = [
  { value: "Urdu", label: "Urdu" },
  { value: "Sindhi", label: "Sindhi" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "Balochi", label: "Balochi" },
  { value: "pashto", label: "Pashto" },
  { value: "English", label: "English" },
];

export const referrers: Option[] = [
  { value: "Friend", label: "Friend" },
  { value: "Family", label: "Family" },
  { value: "Social Media", label: "Social Media" },
  { value: "Newspaper", label: "Newspaper" },
  { value: "Website", label: "Website" },
  { value: "Other", label: "Other" },
];

export const guardianRelations: Option[] = [
  { value: "Uncle", label: "Uncle" },
  { value: "Aunt", label: "Aunt" },
  { value: "Grandfather", label: "Grandfather" },
  { value: "Grandmother", label: "Grandmother" },
  { value: "Brother", label: "Brother" },
  { value: "Sister", label: "Sister" },
  { value: "Other", label: "Other" },
];

// Was a hand-picked ~27-entry subset ("kept short on purpose"). Admin's own
// registration form uses the full 224-entry list (mpa-api's
// src/data/karachiAreas.json, served via the authenticated /transport/areas
// endpoint) — copied verbatim here (same file, same values) so an area
// selected here matches admin's data exactly, not an approximation.
export const karachiAreas: Option[] = karachiAreasData;
